import React, { lazy } from 'react';
import { Gift, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const bonuses = [{
  id: 'B1',
  title: 'Banco de Rutinas por Habilidad',
  desc: 'Rutinas pre-armadas enfocadas en destrabar ese truco que se te resiste.',
  image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&q=80&auto=format&fit=crop'
}, {
  id: 'B2',
  title: 'Guía de Nutrición',
  desc: 'Qué comer para maximizar la fuerza relativa y bajar el porcentaje de grasa.',
  image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&q=80&auto=format&fit=crop'
}, {
  id: 'B3',
  title: 'Entrenamientos Express 30min',
  desc: 'Para esos días sin tiempo. Rutinas densas y efectivas en media hora.',
  image: 'https://images.unsplash.com/photo-1434608519344-49d77a699e1d?w=400&q=80&auto=format&fit=crop'
}, {
  id: 'B4',
  title: 'Equipamiento Casero',
  desc: 'Cómo fabricar paralelas, instalar anillas o barras gastando lo mínimo.',
  image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&q=80&auto=format&fit=crop'
}, {
  id: 'B5',
  title: 'Calentamiento por Articulación',
  desc: 'Preparación articular detallada para hombros, codos y muñecas.',
  image: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=400&q=80&auto=format&fit=crop'
}, {
  id: 'B6',
  title: 'Tracker de Progresión',
  desc: 'Planillas listas para registrar tiempos, repeticiones y sobrecarga progresiva.',
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&q=80&auto=format&fit=crop'
}];
export function BonusesGrid() {
  return <section className="py-10 md:py-20 bg-brand-card border-y border-brand-border relative" data-id="element-16">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-orange/5 via-transparent to-transparent pointer-events-none" data-id="element-17" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-18">
        <FadeIn className="text-center mb-6 md:mb-8" data-id="element-19">
          <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/30 text-green-400 px-3 py-1 rounded-full font-bold tracking-widest text-[10px] md:text-xs mb-3" data-id="element-20">
            <Gift className="w-3 h-3" data-id="element-21" /> INCLUIDOS GRATIS
          </div>
          <h2 className="text-2xl md:text-5xl mb-1" data-id="element-22">
            6 Bonos <span className="text-brand-orange" data-id="element-23">Estratégicos</span>
          </h2>
          <p className="text-xs md:text-sm text-brand-muted" data-id="element-24">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </FadeIn>

        {/* Horizontal rows — 2 columns on desktop, single column on mobile */}
        <div className="grid md:grid-cols-2 gap-2 md:gap-3" data-id="element-25">
          {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.04} data-id="element-26">
              <div className="group flex items-center gap-3 bg-brand-dark border border-brand-border rounded-lg overflow-hidden hover:border-brand-orange/50 hover:bg-brand-cardHover/50 transition-all duration-300 h-full" data-id="element-27">
                {/* Image - thin square on left */}
                <div className="relative w-16 h-16 md:w-20 md:h-20 shrink-0 overflow-hidden" data-id="element-28">
                  <img src={bono.image} alt={bono.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" data-id="element-29" />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-brand-dark/30" data-id="element-30" />
                  {/* ID badge */}
                  <div className="absolute top-1 left-1 bg-brand-card/90 backdrop-blur-sm border border-brand-orange/40 px-1.5 rounded" data-id="element-31">
                    <span className="font-display text-[10px] md:text-xs text-brand-orange leading-tight" data-id="element-32">
                      {bono.id}
                    </span>
                  </div>
                </div>

                {/* Content stretched horizontal */}
                <div className="flex-grow min-w-0 py-2 pr-3" data-id="element-33">
                  <div className="flex items-start justify-between gap-2 mb-0.5" data-id="element-34">
                    <h3 className="text-xs md:text-sm font-bold leading-tight truncate" data-id="element-35">
                      {bono.title}
                    </h3>
                    <span className="bg-brand-orange/15 text-brand-orange text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded shrink-0" data-id="element-36">
                      GRATIS
                    </span>
                  </div>
                  <p className="text-[10px] md:text-xs text-brand-muted leading-snug line-clamp-2" data-id="element-37">
                    {bono.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Total value callout */}
        <FadeIn delay={0.3} className="mt-6 md:mt-8 text-center" data-id="element-38">
          <div className="inline-flex items-center gap-2 border border-dashed border-brand-orange/50 rounded-lg px-3 md:px-5 py-2 md:py-2.5 bg-brand-dark" data-id="element-39">
            <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-orange" data-id="element-40" />
            <p className="text-xs md:text-base font-display tracking-wide" data-id="element-41">
              VALOR TOTAL:{' '}
              <span className="text-brand-muted line-through decoration-red-500/50" data-id="element-42">
                $56.000
              </span>{' '}
              — <span className="text-brand-orange" data-id="element-43">GRATIS</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}